import {remCalc} from '_themeUtils'

const newsletterInput = {
    NewsletterInput: {
        baseStyle: () => ({
            wrapper: {
                w: '100%',
                maxW: {md: remCalc(460)},
                flexDir: {base: 'column', md: 'row'},
                alignItems: 'flexStart',
                gap: 'spacing.none',
            },
        }),
    },
}

export default newsletterInput
